function Spatial() {
    "use strict";
    this.Id = -1;
    this.Version = 0;

    this.CenterLatitude = 0;
    this.CenterLongitude = 0;
    this.IsActive = 1;
    this.Radius = 250;
    this.Shape = 1;
    this.Type = 1;
}
if (typeof exports !== 'undefined') {
    module.exports = Spatial;
}